import localFont from 'next/font/local';

const sourceSans3 = localFont({
    variable: '--font-source-sans-3',
    fallback: ['Arial', 'sans-serif'],
    src: [
        {
            path: '../public/fonts/sourcesans3/SourceSans3-Light.woff2',
            weight: '300',
            style: 'normal',
        },
        {
            path: '../public/fonts/sourcesans3/SourceSans3-Regular.woff2',
            weight: '400',
            style: 'normal',
        },
        {
            path: '../public/fonts/sourcesans3/SourceSans3-SemiBold.woff2',
            weight: '600',
            style: 'normal',
        },
        {
            path: '../public/fonts/sourcesans3/SourceSans3-Bold.woff2',
            weight: '700',
            style: 'normal',
        },
    ],
});

const swedenSans = localFont({
    variable: '--font-sweden-sans',
    fallback: ['lucida console', 'monaco', 'monospace'],
    src: [
        {
            path: '../public/fonts/swedensans/SwedenSans.woff2',
            weight: '400',
            style: 'normal',
        },
        {
            path: '../public/fonts/swedensans/SwedenSansBold.woff2',
            weight: '700',
            style: 'normal',
        },
    ],
});

export default [sourceSans3.variable, swedenSans.variable];
